import accessToSRGDictionary from '@features/access-to-srg/i18n/ru/access-to-srg.dic.json';

export const accessToSRG = {
  ACCESS_TO_SRG: accessToSRGDictionary,
};

export const accessToSRGNamespaces = Object.keys(accessToSRG);
